<template>
  <div>
    <div v-if="!isLoading">
      <b-row class="steps-tunnel w-75 mt-3 mb-5">
        <!-- step1 btn -->
        <b-col cols="auto step-btn-block">
          <div class="step-text">{{ "Le bâtiment" }}</div>
          <b-button
            class="button btn-step mt-4"
            :class="{ 'btn-step-active': currentStep == 1 }"
            @click="changeStep(1)"
          >
            1
          </b-button>
        </b-col>
        <b-col class="step-line"></b-col>
        <!-- step2 btn -->
        <b-col cols="auto step-btn-block">
          <div class="step-text">{{ "La date" }}</div>
          <b-button
            class="button btn-step mt-4"
            :class="{ 'btn-step-active': currentStep == 2 }"
            @click="changeStep(2)"
          >
            2
          </b-button>
        </b-col>
      </b-row>
      <div class="contact-block">
        <appStep1
          v-if="currentStep == 1"
          ref="step-1"
          :meeting="meeting"
          :buildings-options="buildingsOptions"
          @updateMeeting="updateMeeting"
        />
        <appStep2
          v-if="currentStep == 2"
          ref="step-2"
          :meeting="meeting"
          @updateMeeting="updateMeeting"
        />

        <!-- cancel, create, update -->
        <b-row class="mt-5 mb-2 justify-content-end">
          <b-col v-if="currentStep === 2" cols="auto">
            <b-button class="button btn-blue" @click="duplicateMeeting">
              <font-awesome-icon icon="save" />
              <span class="ml-2">{{ $t("general.enregistrer") }}</span>
            </b-button>
          </b-col>
          <b-col v-else cols="auto">
            <b-button class="button btn-blue" @click="goToNextStep">
              <font-awesome-icon icon="arrow-right" />
              <span class="ml-2">{{ $t("general.continue") }}</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </div>
    <appLoader v-else />
  </div>
</template>
<script>
import { validate } from "vee-validate";
import { mapState } from "vuex";
import appStep1 from "./Step1";
import appStep2 from "./Step2";
import MeetingMW from "@/middlewares/Meeting";
import BuildingMW from "@/middlewares/Building";
import BuildingORM from "@/store/orm-axios/models/Building";
export default {
  components: {
    appStep1,
    appStep2,
  },
  props: {
    meetingToDuplicate: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      currentStep: 1,
      step1ok: false,
      step2ok: false,
      meeting: {
        agency_id: Number(localStorage.getItem("agencyId")),
        allowed_modalities: {
          physical: false,
          correspondence: false,
          video: false,
        },
        last_reception_date: null,
        building_id: null,
        name: "",
        meeting_date: new Date(),
        address: "",
        access: "",
        minutes: [],
        freezed_meeting_details: [],
        status: 0,
        meeting_room_name: null,
        meeting_to_duplicate_id: [],
      },
    };
  },
  computed: {
    buildingsOptions() {
      return BuildingORM.query()
        .where("agency_id", this.agencyId)
        .whereHas("voting_categories", query => {
          query.where("is_charge_generale", 1);
        })
        .orderBy("created", "desc")
        .get();
    },
    timezone() {
      return localStorage.getItem("timezone");
    },
  },
  async created() {
    this.isLoading = true;
    this.transferOldMeetingData();
    const buildingProperties = [
      "id",
      "name",
      "agency_id",
      "created",
      { votingCategories: ["id", "is_charge_generale"] },
    ];
    await BuildingMW.QUERY_FETCH_PROPERTIES(this.agencyId, buildingProperties)
      .then(() => {
        this.isLoading = false;
      })
      .catch(err => {
        this.isLoading = false;
      });

    if (this.timezone) {
      this.$moment.tz.setDefault(this.timezone);
    }
  },
  methods: {
    updateMeeting(key, value) {
      this.meeting[key] = value;
    },
    async duplicateMeeting() {
      if (!(await this.validateStep())) {
        return;
      }
      this.isLoading = true;
      await MeetingMW.MEETING_DUPLICATE(this.meeting)
        .then(res => {
          this.isLoading = false;
          this.close();
          if (res.response.data.is_media_missing) {
            this.$swal({
              icon: "warning",
              title: this.$t("duplicate_meeting.warning_message"),
              showConfirmButton: true,
              timer: 20000,
            });
          }
        })
        .catch(err => {
          this.isLoading = false;
          this.close();
          console.log(err);
        });
    },
    async changeStep(stepNb) {
      if (!(await this.validateStep())) {
        return;
      }

      this.currentStep = stepNb;
    },
    async goToNextStep() {
      if (!(await this.validateStep())) {
        return;
      }
      if (this.currentStep == 1) this.step1ok = true;
      if (this.currentStep == 2) this.step2ok = true;
      this.currentStep++;
    },
    async validateStep() {
      var valid = true;
      if (this.currentStep == 1) {
        await validate(this.meeting.name, "required", {}).then(res => {
          if (!res.valid) {
            valid = false;
            this.$refs["step-1"].$refs["vee-meeting-name"].validate();
          }
        });
        await validate(this.meeting.building_id, "required", {}).then(res => {
          if (!res.valid) {
            valid = false;
            this.$refs["step-1"].$refs["vee-meeting-building_id"].validate();
          }
        });
      }
      if (this.currentStep == 2) {
        await validate(this.meeting.meeting_date, "required", {}).then(res => {
          if (!res.valid) {
            valid = false;
            this.$refs["step-2"].$refs["vee-meeting-meeting_date"].validate();
          }
        });
      }
      return valid;
    },
    transferOldMeetingData() {
      this.meeting.address = this.meetingToDuplicate.address;
      this.meeting.allowed_modalities = this.meetingToDuplicate.allowed_modalities;
      this.meeting.building_id = this.meetingToDuplicate.building_id;
      this.meeting.meeting_to_duplicate_id = this.meetingToDuplicate.id;
      this.meeting.access = this.meetingToDuplicate.access;
      this.meeting.show_connection_details = this.meetingToDuplicate.show_connection_details;
      this.meeting.votes_need_recalculations = this.meetingToDuplicate.votes_need_recalculations;
      this.meeting.external_video_solution = this.meetingToDuplicate.external_video_solution;
    },
    close() {
      this.$emit("closeModal");
    },
  },
};
</script>
